import { FirebaseAnalytics } from '@capacitor-firebase/analytics';
import { Capacitor } from '@capacitor/core';

let appOpenLogged = false;

// Firebase Analytics accepts only string and number parameter values; booleans are dropped natively.
export type AnalyticsParams = Record<string, string | number>;

export const logEvent = async (name: string, params?: AnalyticsParams) => {
  try {
    if (!Capacitor.isNativePlatform()) {
      return;
    }
    await FirebaseAnalytics.logEvent({
      name,
      params: params || {},
    });
  } catch (_error) {
    // Silently fail - analytics should not break the app
  }
};

export const logAppOpen = async () => {
  if (!appOpenLogged) {
    appOpenLogged = true;
    await logEvent('app_open');
  }
};
